import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const PurcheshReturnsList = () => {
    const [purcheshReturns, setPurcheshReturns] = useState([]);
    const [filteredPurcheshReturns, setFilteredPurcheshReturns] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}purcheshreturns`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setPurcheshReturns(data.data);
                    setFilteredPurcheshReturns(data.data);
                } else {
                    alert('Failed to fetch purchase returns');
                }
            })
            .catch(error => console.error('Error fetching purchase returns:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = purcheshReturns.filter(item =>
            item.vepari_id.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredPurcheshReturns(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditPurcheshReturn/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddPurcheshReturn');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this return?")) {
            fetch(`${BASE_URL}purcheshreturns/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setPurcheshReturns(purcheshReturns.filter(item => item.id !== id));
                        setFilteredPurcheshReturns(filteredPurcheshReturns.filter(item => item.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting purchase return:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Purchesh Returns List</h3>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="searchTerm" className="form-label">Search by Vepari ID</label>
                                        <input
                                            type="text"
                                            id="searchTerm"
                                            className="form-control"
                                            placeholder="Search Vepari ID"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Purchesh Return</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Vepari ID</th>
                                                <th>PCS Weight</th>
                                                <th>Price</th>
                                                <th>Total</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredPurcheshReturns.map(returnItem => (
                                                <tr key={returnItem.id}>
                                                    <td>{returnItem.id}</td>
                                                    <td>{returnItem.vepari_id}</td>
                                                    <td>{returnItem.pcs_weight}</td>
                                                    <td>{returnItem.price}</td>
                                                    <td>{returnItem.total}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(returnItem.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(returnItem.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PurcheshReturnsList;
